<div class="row justify-content-center align-items-center">
    <div class="col-lg-4 col-md-5 col-sm-12 shadow-lg rounded pb-5 bg-white mt-5">
        <div class="row text-primary">
            <h5 class="mt-3 d-flex justify-content-center pt-5">
                <i class="fas fa-file-signature fa-2xl"></i><br>
            </h5>
            <h5 class="d-flex justify-content-center">
            <p>Signatory Verification</p>
            </h5>
  
        </div>
        <div class="row">
          <span [innerHTML]="'esign.instruction' | translate"></span>
        </div>
        <div class="row">
            <journey-esigning [userType]="'GRP_SIGNER'" [queryString]="queryString"></journey-esigning>
        </div>
        <div class="row smaller-font">
            <div class="mt-3 d-flex justify-content-center">
               	<span [innerHTML]="'esign.contact-info'| translate"></span>
			    </div>
        </div>
    </div>
</div>
